import axios from "axios";
import route from "ziggy-js";
import { sortBy } from "lodash";
import { useQuery } from "@tanstack/vue-query";

const QUERY_KEY = ["users"];

async function fetchUsers() {
    const { data: r } = await axios.get(route("api.preload.users"));
    return r.data;
}

export function useUsers(tenantIds = null, filterType = "all") {
    return useQuery({
        queryKey: QUERY_KEY,
        queryFn: fetchUsers,
        refetchOnMount: true,
        select: (data) => {
            let filteredData = data;

            if (tenantIds) {
                filteredData = data.filter((user) =>
                    tenantIds[getFilterFn(filterType)]((tenantId) =>
                        user.tenants.includes(tenantId)
                    )
                );
            }

            return sortBy(filteredData, "fullname");
        },
    });
}

function getFilterFn(filterType) {
    switch (filterType) {
        case "any":
            return "some";
        case "all":
        default:
            return "every";
    }
}
